import React from "react";
import styled from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import TNPLogoTypeSVG from "core/TNPLogoType";

//styles
import { convertPxToRem } from "frontend/components/helpers";
const TNPLogoTypeStyled = styled.div`
    position: relative;
    top: ${convertPxToRem(5)};
`;

// component
export const TNPLogoType = () => {
    const { isDarkMode } = useSiteHeader();
    return (
        <TNPLogoTypeStyled>
            <TNPLogoTypeSVG isDarkMode={isDarkMode} />
        </TNPLogoTypeStyled>
    );
};

export default TNPLogoType;
